import React, { useState, useEffect, useRef} from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { getAllUploadedFile } from "../../../../redux/slice/filesUploadSlice";
import { useDocumentUpload } from "../../../../hooks/useDocumentUpload";
import DetailCard from "./DetailCard";
import EditDocModal from "./EditDocModal";
import ValidateFile from "utils/ValidateFile";

export default function EmployeeDocs() {
    const dispatch = useDispatch();
    const params = useParams();
    const userId = params?.id;  // EmpID
    const [activeTabView, setActiveTabView] = useState("list");
    const fileInputRef = useRef(null);
    const [activeFileType, setActiveFileType] = useState("");
    const [selectedEditFile, setSelectedEditFile] = useState(null);
    const { allFiles, fetchAllStatus } = useSelector((state) => state.filesUpload);
    const { handleFileSelect, handleViewFile } = useDocumentUpload({ candidateId: userId });

    useEffect(() => {
        if (userId) {
            dispatch(getAllUploadedFile(userId));
        }
    }, [dispatch, userId]);

    useEffect(() => {
        // Only trigger if activeFileType actually has a value
        if (activeFileType && fileInputRef.current) {
            fileInputRef.current.click();
        }
    }, [activeFileType]);

    const handleEditClick = (type) => {
        setActiveFileType(type);
    };

    const onFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const allowedFormats = validationRules[activeFileType.toLowerCase()] || validationRules.default;
        const validationResult = ValidateFile(file, allowedFormats);

        if (validationResult !== true) {
            toast.error(validationResult, { className: "toast-error-custom", autoClose: 5000, });
            e.target.value = "";
            return;
        }

        setSelectedEditFile({
            file: file,
            type: activeFileType
        })
        handleFileSelect(activeFileType, file);
        setActiveFileType("");
        e.target.value = "";
    }

    const fileAcceptMapping = {
        offerletter: ".pdf",
        aadhaarcard: ".pdf, .jpeg,",
        pancard: ".jpg, .jpeg",
        passbookfrontimage: ".jpg, .jpeg",
        cancelledcheque: ".jpg, .jpeg",
        default: ".pdf, .doc, .docx, .jpg, .jpeg, .png"
    };
    const currentAcceptValue = fileAcceptMapping[activeFileType.toLowerCase()] || fileAcceptMapping.default;

    const validationRules = {
        offerletter: ['application/pdf'],
        aadhaarcard: ['application/pdf', 'image/jpeg', 'image/jpg'],
        pancard: ['image/jpeg', 'image/jpg'],
        passbookfrontimage: ['image/jpeg', 'image/jpg'],
        cancelledcheque: ['image/jpeg', 'image/jpg'],
        default: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
    };

    const formatDateTime = (isoString) => {
        if (!isoString) return { date: "N/A", time: "N/A" };

        const dateObj = new Date(isoString);
        const date = dateObj.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });

        const time = dateObj.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });

        return { date, time };
    };

    return (
        <div className="container-fluid">

            {/* user list table */}
            <div className="section-body">
                <div className="container-fluid">
                    <div className="tab-content">
                        <div className="tab-pane fade active show" id="Employee-list" role="tabpanel" >
                            {fetchAllStatus === "loading" && (<p className="loading">Loading...</p>)}
                            {fetchAllStatus === "failed" && (<p className="server-error-msg">Unable to connect to server</p>)}
                            {fetchAllStatus == "succeeded" && (
                                allFiles?.length === 0 ?
                                    (
                                        <p className="loading">No files found</p>
                                    ) :
                                    (
                                        <div>
                                            <ul className="nav" style={{ justifyContent: "flex-end", margin: "10px 0" }}>
                                                <li className="nav-item">
                                                    <button
                                                        className={`toggle-first-btn nav-link ${activeTabView === "list" ? "btn-active" : "inactive"}`}
                                                        title="List view"
                                                        onClick={() => setActiveTabView('list')}
                                                    >
                                                        List
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={`toggle-second-btn nav-link ${activeTabView === "grid" ? "btn-active" : "inactive"}`}
                                                        title="Grid view"
                                                        onClick={() => setActiveTabView('grid')}
                                                    >
                                                        Grid
                                                    </button>
                                                </li>
                                            </ul>
                                            {activeTabView === "list" && (
                                                <div className="card">
                                                    <div className="card-header">
                                                        <div className="card-body">

                                                            <div className="user-table">
                                                                <table
                                                                    id="candidate-table"
                                                                    className="table table-hover table-vcenter text-nowrap mb-0"
                                                                >
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ width: "55px", textAlign: "center" }}>S.No.</th>

                                                                            <th> Name </th>
                                                                            <th>Created on </th>
                                                                            <th>Updated on </th>
                                                                            <th
                                                                                ref={(el) => {
                                                                                    if (el) {
                                                                                        el.style.setProperty("padding", "0", "important");
                                                                                        el.style.setProperty("width", "55px");
                                                                                        el.style.setProperty("text-align", "center");
                                                                                    }
                                                                                }}
                                                                            >
                                                                                Action
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {allFiles.map((data, index) => (
                                                                            <tr key={data.id}>
                                                                                <td>{index + 1}.</td>
                                                                                <td>
                                                                                    {data.fileType}
                                                                                </td>
                                                                                <td>
                                                                                    {formatDateTime(data.createdAt)?.date ?? "-"}
                                                                                </td>
                                                                                <td>
                                                                                    {formatDateTime(data.updatedAt)?.date ?? "-"}
                                                                                </td>
                                                                                <td className="action-column">
                                                                                    <PopupState variant="popover" popupId="demo-popup-menu">
                                                                                        {(popupState) => (
                                                                                            <>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-icon btn-sm icons"
                                                                                                    title="view"
                                                                                                    {...bindTrigger(popupState)}
                                                                                                >
                                                                                                    <img
                                                                                                        src={require("assets/img/more.png")}
                                                                                                        alt="view"
                                                                                                        className="action-icon"
                                                                                                       
                                                                                                    />
                                                                                                </button>
                                                                                                <Menu {...bindMenu(popupState)}>
                                                                                                    <MenuItem
                                                                                                        onClick={() => {
                                                                                                            popupState.close();
                                                                                                            handleViewFile(data.fileType)
                                                                                                        }}
                                                                                                    >
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-icon btn-sm icons"
                                                                                                        >
                                                                                                            <img
                                                                                                                src={require("assets/img/view-icon.png")}
                                                                                                                alt="view"
                                                                                                                className="action-icon"
                                                                                                            />
                                                                                                        </button>{" "}
                                                                                                        View
                                                                                                    </MenuItem>
                                                                                                    <MenuItem
                                                                                                        onClick={() => {
                                                                                                            popupState.close();
                                                                                                            handleEditClick(data.fileType)
                                                                                                        }}
                                                                                                    >
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-icon btn-sm icons"
                                                                                                        >
                                                                                                            <img
                                                                                                                src={require("assets/img/edit-icon.png")}
                                                                                                                alt="Edit"
                                                                                                            />
                                                                                                        </button>{" "}
                                                                                                        Edit
                                                                                                    </MenuItem>
                                                                                                </Menu>
                                                                                            </>
                                                                                        )}
                                                                                    </PopupState>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                                <input
                                                                    type="file"
                                                                    ref={fileInputRef}
                                                                    style={{ display: 'none' }}
                                                                    accept={currentAcceptValue}
                                                                    onChange={onFileChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div className='row'>
                                                {activeTabView === "grid" && (allFiles.map((data, id) => (
                                                    <DetailCard key={data.id} title={data.fileType} userId={userId}
                                                        iconClass="bi bi-envelope-check" bgColor="bg-teal-light"
                                                    />
                                                ))
                                                )}
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
                {selectedEditFile && (
                    <EditDocModal
                        onHide={() => setSelectedEditFile(null)}
                        title={selectedEditFile.type}
                        file={selectedEditFile.file}
                        userId={userId}
                    />
                )
                }
            </div>
            <ToastContainer />
        </div>
    );
}
